import {Component, OnInit} from '@angular/core';
import {Aarogyam, Iilds, Karad, Medikal, Nepal, Tata, Turkish} from '../../shared/my-constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: []
})
export class FooterComponent implements OnInit {
    iilds: Boolean = Iilds;
    nepal: Boolean = Nepal;
    tata: Boolean = Tata;
    aarogyam: Boolean = Aarogyam;
    turkish: Boolean = Turkish;
    medikal: Boolean = Medikal;
    karad: Boolean = Karad;
    constructor() {
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/footer/footer.component.ts